

import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'infomodal',
    components: {
        accountselector: require('../account/AccountSelect.vue').default
    }
})
export default class InfomodalComponent extends Vue {
  @Prop({ default: '' })
    readonly currentAccountName!: string;
}
